/* eslint-disable */
import React, { useState, useEffect } from "react";
import * as API from "../../framework/API/api";
import { ASSETTYPE, ENTITYNAME, FILEURL, LOCALSTORAGE_KEY, VOD_EXPORT_XML_TYPE } from "../../framework/constant/constant";
import { utility } from "../../framework/utility/utilityProvider";
import { toast } from 'react-toastify';
import { Grid, GridColumn as Column, GridNoRecords } from "@progress/kendo-react-grid";
import ActionButton from "../../framework/forms/helpercomponents/buttons/ActionButton";
import RoundButton from "../../framework/forms/helpercomponents/buttons/RoundButton";
import { useTranslation } from "../../locale/useTranslation";
import CollectionSelection from "../../framework/forms/CollectionSelection";
import { TimeCell } from "../../framework/forms/helpercomponents/CustomGridCells/TimeCell";
import OttAssetCollectionSelection from "../../framework/OTT/OttAssetCollectionSelection";
import { DateOnlyCell } from "../../framework/forms/helpercomponents/CustomGridCells/DateCell";

export const VODReport = () => {

    const lang = useTranslation();
    const Company = utility.getValue(LOCALSTORAGE_KEY.COMPANY);
    const [gridData, setGridData] = useState([]);
    const [loadingStatus, setLoadingStatus] = useState(`${lang.no_record_found_error_message}`);
    const [addAsset, setAddAsset] = useState(false);
    useEffect(() => {
        
    }, []);

   const handleAssetLibrary = (dataList) => {
    setLoadingStatus(lang.no_record_found_error_message);
    const updatedList = dataList.map(item => ({
        ...item,
        Title: utility.getItemDisplayValueByLang(item.Title, Company.Language)
    }));
    let newData = utility.checkDuplicateInData(updatedList, gridData, "Description");
    setGridData([...gridData, ...newData]);
};


    const loadData = async () => {
        if (gridData.length === 0) {
            toast.error(lang.no_record_found_error_message, {
                position: toast.POSITION.TOP_RIGHT
            });
            return;
        }
        const ids = gridData.map(x => x._id);
        let res = await API.getVODReport(ids);
        console.log(res);
        if (res.success) {
            window.open(FILEURL.BASEURL + 'downloadReport/' + res.data)
            toast.success(`${lang.successfully_download_success_message}`, {
                position: toast.POSITION.TOP_RIGHT
            });
        }
        else {
            toast.error(res.message, {
                position: toast.POSITION.TOP_RIGHT
            });
        }
    };

    const exportVODXML = async (type) => {
        console.log(type);
        if (gridData.length === 0) {
            toast.error(lang.no_record_found_error_message, {
                position: toast.POSITION.TOP_RIGHT
            });
            return;
        }
        const ids = gridData.map(x => x._id);
        let res = await API.exportVODXML(ids, type);
        console.log(res);
        if (res.success) {
            window.open(FILEURL.BASEURL + 'downloadReport/' + res.data)
            toast.success(`${lang.successfully_download_success_message}`, {
                position: toast.POSITION.TOP_RIGHT
            });
        }
        else {
            toast.error(res.message, {
                position: toast.POSITION.TOP_RIGHT
            });
        }
    };

    const addOttAsset = (data) => {
        setAddAsset(true);
        }


    return (<>
        <h1 className="page-title txt-color-bludeDark">
            <i
                className="fa fa-table marlr"
                style={{ fontSize: "20px", color: "GrayText" }}
            ></i>
            <span>{lang.vod_report_page_breadcrumb}</span>
        </h1>
        <div className="row m-1">
            <div className="col-12">
                <div className="row">
                    <div className="col-12 d-flex justify-content-between align-items-center">
                        <RoundButton icon='plus' onClick={addOttAsset} style={{ marginLeft: '10px' }} title={lang.download_button_tooltip} />
                        <div className="d-flex gap-2">
                        <ActionButton name={lang.export_button_text} onClick={loadData} />
                        <ActionButton title={lang.export_appendix8_tooltip} name={lang.appendix8} onClick={() => exportVODXML(VOD_EXPORT_XML_TYPE.APPENDIX8)} />
                        <ActionButton title={lang.export_appendix11_tooltip} name={lang.appendix11} onClick={() => exportVODXML(VOD_EXPORT_XML_TYPE.APPENDIX11)} />
                        <ActionButton title={lang.export_appendix12_tooltip} name={lang.appendix12} onClick={() => exportVODXML(VOD_EXPORT_XML_TYPE.APPENDIX12)} />
                        </div>
                    </div>                    
                </div>
                <div className="row mt-3">
                    <div className="col-12">
                        <Grid data={gridData} style={{ height: '76vh' }} resizable={true}>
                            <GridNoRecords>{loadingStatus}</GridNoRecords>
                            <Column field="Title" title={lang.title_column} />
                            <Column field="Description" title={lang.description_column} /> 
                            <Column field="Source.MediaCategory.Description" title={lang.media_category_column} />                        
                            <Column field="StartDate" title={lang.start_date_column} cell={DateOnlyCell} />
                            <Column field="EndDate" title={lang.end_date_column} cell={DateOnlyCell}/>
                        </Grid>
                    </div>
                </div>
            </div>
        </div>
        {addAsset && <CollectionSelection addButtonTitle={lang.select_button_text} title={lang.ott_asset_library_dialog_header} wherestatement={["OttAssetTypeSID", "=", ASSETTYPE["Media Asset"]]} setDataList={handleAssetLibrary} entityname={ENTITYNAME.OttAsset} closeForm={() => setAddAsset(false)} mode={'multiple'} width={"60vw"} />}
            
    </>)
}
export default VODReport;